import React from 'react';
import PropTypes from 'prop-types';
import { View, Animated, StyleSheet } from 'react-native';
import R from '../../core-res/R';
import DRNText from '../../standard/Text/DRNText';
import { withTheme } from '../../theme';
class DRNProgressBar extends React.Component {
    constructor(props) {
        super(props);
        this.animation = new Animated.Value(props.currentPercentage / 100);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.currentPercentage !== this.props.currentPercentage) {
            const duration = (this.props.transitionDuration / 10) * (this.props.currentPercentage - prevProps.currentPercentage);
            Animated.timing(this.animation, {
                toValue: this.props.currentPercentage / 100,
                duration,
            }).start();
        }
    }
    render() {
        const { helperText, errorText, currentPercentage, style, showPercentage, theme } = this.props;
        const widthInterpolated = this.animation.interpolate({
            inputRange: [0, 1],
            outputRange: ['0%', '100%'],
            extrapolate: 'clamp',
        });
        let backgroundBar = theme.tintPrimary;
        if (errorText) {
            backgroundBar = R.color.uiRedDark;
        }
        return (<View style={[styles.wrapper, { backgroundColor: theme.lightPrimary }, style]}>
        <View style={{ flex: 1 }}>
          <View style={[styles.container, { backgroundColor: theme.lightSecondary }]}>
            <Animated.View style={[styles.animatedView, { width: widthInterpolated, backgroundColor: backgroundBar }]}/>
          </View>
          <View style={styles.messageArea}>
            {!errorText &&
            helperText && <DRNText style={[styles.hint, { color: theme.textSecondary }]}>{helperText}</DRNText>}
            {errorText && <DRNText style={styles.error}>{errorText}</DRNText>}
            {showPercentage &&
            !errorText && (<DRNText style={[styles.progressInfo, { color: theme.textSecondary }]}>{`${currentPercentage}%`}</DRNText>)}
          </View>
        </View>
      </View>);
    }
}
DRNProgressBar.propTypes = {
    style: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({})]),
    currentPercentage: PropTypes.number,
    helperText: PropTypes.string,
    errorText: PropTypes.string,
    transitionDuration: PropTypes.number,
    showPercentage: PropTypes.bool,
    theme: PropTypes.object,
};
DRNProgressBar.defaultProps = {
    currentPercentage: 0,
    helperText: null,
    errorText: null,
    transitionDuration: 100,
    showPercentage: true,
};
const styles = StyleSheet.create({
    wrapper: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
    container: {
        overflow: 'hidden',
        borderRadius: R.border.radius.default,
        alignSelf: 'stretch',
        height: 3,
    },
    animatedView: {
        position: 'absolute',
        borderRadius: R.border.radius.default,
        left: 0,
        top: 0,
        bottom: 0,
    },
    messageArea: {
        flexDirection: 'row',
        alignSelf: 'stretch',
    },
    progressInfo: Object.assign({ textAlign: 'right', flex: 1 }, R.typography.uiTiny),
    hint: Object.assign({ flex: 4 }, R.typography.uiTiny),
    error: Object.assign({ color: R.color.uiRedDark, flex: 4 }, R.typography.uiTiny),
});
export default withTheme(DRNProgressBar);
